export function cityStateCheck(str) {
   return /^[, a-zA-Z]+$/.test(str);
}
export function postalCodeCheck(str) {
   return /^\d{5}$/.test(str);
}
